// Test.jsx
import React, { Component } from 'react'
// connect方法的作用：将额外的props传递给组件，并返回新的组件，组件在该过程中不会受到影响
import { connect } from 'react-redux'
// 引入action
// import { setPageTitle } from '../../store/actions.js'
import { HashRouter as Router, Route, Link } from "react-router-dom";

import SollTab from "../../components/com_home/sollTab"
import Board from '../board'
import Default from './default'
import Writeart from '../writeart'
import article from '../article';
import FriendsLink from '../friendsLink';
import LoginPage from '../login';
import About from '../about';
class Home extends Component{
    
    render(){
        return(
            
            <>
        
   
                <Route exact path='/' component={Default}></Route>
                <Route exact path='/Search' component={Default}></Route>
                <Route exact path='/Board' component={Board}></Route>
                <Route exact path='/Writeart' component={Writeart}></Route> 
                <Route exact path='/Article' component = {article}></Route>
                <Route exact path='/FriendsLink' component = {FriendsLink}></Route>
                <Route exact path='/LoginPage' component = {LoginPage}></Route>
                <Route exact path='/About' component = {About}></Route>
                
                
                </>
        )
    }
}

export default connect()(Home)